import GenericResourceUnlockSection from './GenericResourceUnlockSection.vue'
import GenericResourceClassifySection from './GenericResourceClassifySection.vue'
import GenericResourceTagSection from './GenericResourceTagSection.vue'
import GenericResourceFilterSection from './GenericResourceFilterSection.vue'
import GenericResourceOtherSection from './GenericResourceOtherSection.vue'

export const GENERIC_RESOURCE_GOVERNANCE_COMPONENTS = {
  GenericResourceUnlockSection,
  GenericResourceClassifySection,
  GenericResourceTagSection,
  GenericResourceFilterSection,
  GenericResourceOtherSection,
}

export default GENERIC_RESOURCE_GOVERNANCE_COMPONENTS
